export function toOptionalId(
  value: string | number | undefined | null
): string | undefined {
  return value === undefined || value === null ? undefined : String(value);
}
